import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const DollarIcon = createIcon({
  displayName: 'DollarIcon',
  path: (
    <>
      <path stroke='none' d='M0 0h24v24H0z' />
      <path d='M16.7 8A3 3 0 0 0 14 6h-4a3 3 0 0 0 0 6h4a3 3 0 0 1 0 6h-4a3 3 0 0 1-2.7-2M12 3v3m0 12v3' />
    </>
  ),
  defaultProps: {
    ...defaultProps,
    fill: 'none',
    stroke: 'currentColor',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    strokeWidth: '2'
  }
})
